module.exports = __webpack_public_path__ + "img/banner-gender-equality.f310f497.png";